module.exports = __webpack_public_path__ + "img/output-6.22bb4ed2.png";